import { z } from 'zod'

import { StudentIdSchema } from '~/@entities/Student'

/** 선생님이 수행한 시나리오 단계를 가리키는 키. 서버는 내용을 해석하지 않고 앱이 정한 문자열을 그대로 저장한다 */
export const ScenarioUnitIdSchema = z.string()
export type ScenarioUnitId = z.infer<typeof ScenarioUnitIdSchema>

/** 시나리오 안내가 이동할 학생. 조건에 맞는 학생이 없으면 null 이다 */
export const ScenarioLatestStudentIdSchema = StudentIdSchema.nullable()
